import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import { createFormData } from '../helpers/createFormdata';

interface CreateSectorParams {
	propId: string;
	areaId: string;
	data: {
		name: string;
		areaId: string;
		size: number;
		plantingDate: string;
		amountOfPlants: number;
		plantSpacing: number;
		lineSpacing: number;
		avatar?: File | null;
	};
}

interface CreateSectorResponse {
	_id: string;
	[key: string]: unknown;
}

export function usePostSector() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({ propId, areaId, data }: CreateSectorParams) => {
			try {
				const { avatar, ...sectorData } = data;
				const formData = createFormData({ ...sectorData, file: avatar });
				return (
					await api.post<CreateSectorResponse>(
						`/user/prop/${propId}/area/${areaId}/sector/create`,
						formData,
						{ params: { forBinding } }
					)
				).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar setor');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['sectors'] });
			queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] });
		},
		onError: (error) =>
			console.error('Erro ao criar setor:', getApiErrorMessage(error, 'Erro ao criar setor')),
	});
}
